import { identity } from 'lodash';
import { queryTags } from '@wix/ambassador-blog-v3-tag/http';
import { SortOrder } from '@wix/ambassador-blog-v3-tag/types';
import createAction from '../../services/create-action';
const DEFAULT_TAGS_LIMIT = 100;
export const fetchTagsRequest = createAction('tags/FETCH_REQUEST');
export const fetchTagsSuccess = createAction('tags/FETCH_SUCCESS', (payload, _meta) => payload, (_, meta) => meta);
export const fetchTagsFailure = createAction('tags/FETCH_FAILURE');
const createTagsFilter = (params) => {
    const filters = [
        params.onlyWithPublishedPosts && { publishedPostCount: { $gt: 0 } },
        params.labelStarts && { label: { $startsWith: params.labelStarts } },
        params.language && { language: { $eq: params.language } },
    ].filter(identity);
    return filters.length > 1 ? { $and: filters } : filters[0] || {};
};
const createTagsQueryRequest = (params) => ({
    query: {
        filter: createTagsFilter(params),
        paging: {
            offset: 0,
            limit: params.limit ?? DEFAULT_TAGS_LIMIT,
        },
        ...(params.mostPopular && {
            sort: [{ fieldName: 'publishedPostCount', order: SortOrder.DESC }],
        }),
    },
});
const fetchTags = (params = {}) => async (dispatch, _getState, { httpClient, errorHandler }) => {
    const { withErrorHandler, getResolvedError } = errorHandler;
    dispatch(fetchTagsRequest());
    try {
        const response = await withErrorHandler(() => httpClient.request(queryTags(createTagsQueryRequest(params))), {
            errorCodesMap: {},
        });
        const tags = response.data.tags;
        dispatch(fetchTagsSuccess(tags ?? [], Boolean(params.mostPopular)));
    }
    catch (error) {
        getResolvedError(error);
        dispatch(fetchTagsFailure());
    }
};
export default fetchTags;
//# sourceMappingURL=fetch-tags.js.map